import {Component, Inject, Injectable, OnInit, Optional} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {SubscriptionService} from '@services/subscription/subscription.service';
import {AccountService} from '@services/account/account.service';
import {Store} from '@ngrx/store';
import * as AuthReducer from '@store/auth/reducers';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';
import {Subject} from 'rxjs';
import {ViewChild} from '@node_modules/@angular/core';
import {GooglePlaceDirective} from '@node_modules/ngx-google-places-autocomplete';
import {BehaviorSubject} from 'rxjs/internal/BehaviorSubject';
import {UpdateAuthUser} from '@store/auth/actions';
import {User} from '@models/user';
import {ActivatedRoute, Router} from '@node_modules/@angular/router';
import {ErrorResponse} from '@interfaces/responses/error-response';

@Component({
  selector: 'app-edit-subscription-page',
  templateUrl: './edit-subscription-page.component.html',
  styleUrls: ['./edit-subscription-page.component.scss']
})
@Injectable()
export class EditSubscriptionPageComponent implements OnInit {

  createSubForm: FormGroup;
  subscribes = [];
  user: User;
  scenarios: [];
  errors: [];
  sub;
  sub_id: number = 0;
  tmpAddress: {
    address: string,
    locality: string,
    administrative_area_level_1: string,
    postal_code: string,
    country: string
  } = {
    address: null,
    locality: null,
    administrative_area_level_1: null,
    postal_code: null,
    country: null
  };
  mask$: Subject<string> = new BehaviorSubject(null);
  currentPhoneFormat;
  currentCountryCode;
  trialStatus: boolean = false;
  termsFileToUpload: File = null;
  isTermsFileUploaded: boolean = false;
  uploadedTermsFileName: string = null;

  constructor(
    public dialog: MatDialog,
    @Optional() public dialogRef: MatDialogRef<EditSubscriptionPageComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public dialogData: {subId?: number},
    private router: Router,
    private route: ActivatedRoute,
    private subscriptionService: SubscriptionService,
    private accountService: AccountService,
    private authStore: Store<AuthReducer.AuthState>
  ) { }

  ngOnInit() {
    this.errors = [];
    this.errors['name'] = null;
    this.errors['scenario_id'] = null;
    this.errors['description'] = null;
    this.errors['trial_status'] = null;
    this.errors['trial_duration'] = null;
    this.errors['trial_duration_name'] = null;

    this.subscriptionService.getAllScenario().subscribe(
      (resp: {data: any}) => {
        this.scenarios = resp.data;
      }
    );

    this.sub_id = Number((this.dialogData && this.dialogData.subId) || this.route.snapshot.params['subId'] || 0);
    this.subscriptionService.getAdminSubById(this.sub_id).subscribe(
      (resp: { data: any }) => {
        this.sub = resp.data[0] ? resp.data[0] : resp.data;

        this.createSubForm.get('name').setValue(this.sub.name);
        this.createSubForm.get('description').setValue(this.sub.description);
        this.createSubForm.get('scenario_id').setValue(this.isDropdownCtaValue(this.sub.scenario_id) ? '' : this.sub.scenario_id);
        // this.createSubForm.get('direct_debit').setValue(this.sub.direct_debit);
        // this.createSubForm.get('membership_builder').setValue(this.sub.membership_builder);
        // this.createSubForm.get('internal_mail').setValue(this.sub.internal_mail);
        // this.createSubForm.get('payroll_payments').setValue(this.sub.payroll_payments);
        // this.createSubForm.get('curriculum_builder').setValue(this.sub.curriculum_builder);
        // this.createSubForm.get('check_in').setValue(this.sub.check_in);
        // this.createSubForm.get('trial_period').setValue(this.sub.trial_period);
        this.createSubForm.get('trial_status').setValue(this.sub.trial_status?"1":"0");
        this.createSubForm.get('trial_duration').setValue(this.sub.trial_duration);
        this.createSubForm.get('trial_duration_name').setValue(this.isDropdownCtaValue(this.sub.trial_duration_name) ? '' : this.sub.trial_duration_name);

        // set trial status for subscription
        this.trialStatus = this.sub.trial_status == true;
        if (!this.trialStatus) {
          this.createSubForm.controls['trial_duration'].setValue(null);
          this.createSubForm.controls['trial_duration_name'].setValue('');
        }
      }
    );

    this.createSubForm = new FormGroup({
      'name': new FormControl(null, [Validators.required]),
      'description': new FormControl(null),
      'scenario_id': new FormControl(''),

      'enable_all': new FormControl(true),
      'direct_debit': new FormControl(true),
      'membership_builder': new FormControl(true),
      'internal_mail': new FormControl(true),
      'payroll_payments': new FormControl(true),
      'curriculum_builder': new FormControl(true),
      'check_in': new FormControl(true),
      'trial_period': new FormControl(true),

      'currency': new FormControl(null),
      'total_price': new FormControl(null),
      'charged_per': new FormControl(null),
      'billed_to': new FormControl(null),
      'frequency_name': new FormControl(null),
      'trial_status': new FormControl(''),
      'trial_duration': new FormControl({value: null, disabled: !this.trialStatus}),
      'trial_duration_name': new FormControl({value: '', disabled: !this.trialStatus}),
      'terms_and_conditionals': new FormControl(null),
    });

    this.createSubForm.controls['trial_status'].valueChanges.subscribe(value => {
      this.trialStatus = value == true

      if (this.trialStatus === false) {
        this.createSubForm.controls['trial_duration'].disable();
        this.createSubForm.controls['trial_duration_name'].disable();
        this.createSubForm.controls['trial_duration'].setValue(null);
        this.createSubForm.controls['trial_duration_name'].setValue('');
      } else {
        this.createSubForm.controls['trial_duration'].enable();
        this.createSubForm.controls['trial_duration_name'].enable();
      }
    });
  }

  create() {
    const trialStatus = this.createSubForm.get('trial_status').value == true;
    const trialDuration = this.createSubForm.get('trial_duration').value;
    const trialDurationName = this.createSubForm.get('trial_duration_name').value;

    this.errors['name'] = null;
    this.errors['scenario_id'] = null;
    this.errors['description'] = null;
    this.errors['trial_status'] = null;
    this.errors['trial_duration'] = null;
    this.errors['trial_duration_name'] = null;

    if (this.createSubForm.get('name').value == null) {
      this.errors['name'] = 'This field is required';
      return;
    }
    if (this.createSubForm.get('description').value == null) {
      this.errors['description'] = 'This field is required';
      return;
    }
    if (this.isDropdownCtaValue(this.createSubForm.get('scenario_id').value)) {
      this.errors['scenario_id'] = 'This field is required';
      return;
    }
    if (this.isDropdownCtaValue(this.createSubForm.get('trial_status').value)) {
      this.errors['trial_status'] = 'This field is required';
      return;
    }
    if (this.createSubForm.get('trial_status').value == 1 && this.createSubForm.get('trial_duration').value == null) {
      this.errors['trial_duration'] = 'This field is required';
      return;
    }
    if (this.createSubForm.get('trial_status').value == 1 && this.isDropdownCtaValue(this.createSubForm.get('trial_duration_name').value)) {
      this.errors['trial_duration_name'] = 'This field is required';
      return;
    }

    if (this.uploadedTermsFileName == null && !this.sub.terms_and_conditionals) {
      this.errors['terms_and_conditionals'] = 'This field is required';
      return;
    }

    this.subscriptionService.updateSub({
      id: this.sub.id,
      name: this.createSubForm.get('name').value,
      display_name: this.createSubForm.get('name').value,
      description: this.createSubForm.get('description').value,
      scenario_id: this.createSubForm.get('scenario_id').value,
      // enable_all: this.createSubForm.get('enable_all').value?1:0,
      direct_debit: this.createSubForm.get('direct_debit').value?1:0,
      membership_builder: this.createSubForm.get('membership_builder').value?1:0,
      internal_mail: this.createSubForm.get('internal_mail').value?1:0,
      payroll_payments: this.createSubForm.get('payroll_payments').value?1:0,
      curriculum_builder: this.createSubForm.get('curriculum_builder').value?1:0,
      check_in: this.createSubForm.get('check_in').value?1:0,
      trial_period: this.createSubForm.get('trial_period').value?1:0,
      // currency: this.createSubForm.get('currency').value,
      // total_price: this.createSubForm.get('total_price').value,
      charged_per: 'school', //this.createSubForm.get('charged_per').value,
      billed_to: 'owner', //this.createSubForm.get('billed_to').value,
      frequency_name: this.createSubForm.get('frequency_name').value?this.createSubForm.get('frequency_name').value:'month',
      trial_status: trialStatus,
      trial_duration: trialDuration && trialStatus ? trialDuration : 1,
      trial_duration_name: trialDurationName && trialStatus  ? trialDurationName : 'day',
      terms_and_conditionals: this.uploadedTermsFileName ? this.uploadedTermsFileName : null,
    }).subscribe(
      (resp: {data: {}}) => {
        this.closeOrNavigate(true);
      },

      (err: ErrorResponse) => {
        Object.keys(err.error.errors).map(item => {
          this.errors[item] = err.error.errors[item];
          console.log(item);
        });
      }
    );
  }

  handleAddressChange(event) {
    // console.log(event);
    if ( Object.keys(event).every(item => {
      return event[item].length > 0;
    })) {
      let address: any;
      address = event.address_line_1 ? event.address_line_1 : event.administrative_area_level_1 ? event.administrative_area_level_1 : event.country;
      this.tmpAddress.address = event.address_line_1;
      this.tmpAddress.locality = event.locality;
      this.tmpAddress.administrative_area_level_1 = event.administrative_area_level_1;
      this.tmpAddress.postal_code = event.postal_code;
      this.tmpAddress.country = event.country;

      this.createSubForm.get('address').setValue(address);
      this.createSubForm.get('locality').setValue(event.locality);
      this.createSubForm.get('administrative_area_level_1').setValue(event.administrative_area_level_1);
      this.createSubForm.get('postal_code').setValue(event.postal_code);
      this.createSubForm.get('country').setValue(event.country);
    } else {
      this.tmpAddress.address = '';
      this.tmpAddress.locality = '';
      this.tmpAddress.administrative_area_level_1 = '';
      this.tmpAddress.postal_code = '';
      this.tmpAddress.country = '';
    }
  }

  onPhoneError(event) {
    this.createSubForm.get('phone').setErrors({'range': true});
  }

  onCountrychange(event) {
    this.currentCountryCode = event.countryData.dialCode;
    this.currentPhoneFormat = event.placeholder;
    this.mask$.next(event.mask.replace(/[0-9]/g, "0"));
  }

  genCancel(){
    this.closeOrNavigate();
  }

  handleTermsFileInput(files: FileList) {
    this.termsFileToUpload = files.item(0);
    this.isTermsFileUploaded = false;
    this.uploadedTermsFileName = null;

    if (this.termsFileToUpload && !this.isTermsFileUploaded) {
      this.uploadTermsFile(files.item(0));
    }
  }

  uploadTermsFile(file: File) {
    this.subscriptionService
      .updateTermsFile(file)
      .subscribe(
        (resp: {data}) => {
          this.termsFileToUpload = null;
          this.isTermsFileUploaded = true;

          if (resp && resp['name'] != '') {
            this.uploadedTermsFileName = resp['name'];
            console.log('this.uploadedTermsFileName', this.uploadedTermsFileName);
          }
        },
        (err: ErrorResponse) => {
          Object.keys(err.error.errors).map(item => {
            console.log(item);
            this.errors[item] = err.error.errors[item];
          });
        }
      );
  }

  private closeOrNavigate(result?: boolean) {
    if (this.dialogRef) {
      this.dialogRef.close(result);
      return;
    }

    this.router.navigate(['/subscriptions']);
  }

  private isDropdownCtaValue(value: any): boolean {
    return value === null || value === undefined || value === '';
  }
}
